// extracted by mini-css-extract-plugin
module.exports = {"container":"eZ","image":"e0","title":"e1","desc":"e2"};